import Editor from 'react-simple-wysiwyg';

const MainEditor = ({ html, setHtml }) => {
    // const [html, setHtml] = useState('Enter <b>content</b>');

    function onChange(e) {
        setHtml(e.target.value);
    }

    return (
        <Editor
            value={html}
            onChange={onChange}
            style={{ minHeight: '250px', width: '100%', border: '1px solid #ccc' }} // Set custom height here
        />
    );
};

export default MainEditor;